import { useQuery } from '@tanstack/react-query';
import { ApiConfigs, KeyQueryApi } from '../config/apiConfig';
import apiClient from '../services/api/apiClient';
import { PostTypeKey } from '../types/common.type';
import { ResponseDataDashboard } from '../types/home.type';

export const fetchPostHomeData = async (
  type: PostTypeKey,
  params?: paramsGetListInterface
): Promise<ResponseDataDashboard> => {
  // Use centralized API client and include trailing slash to avoid redirect
  const endpoint = `/home/${type}/`;
  const response = await apiClient.get<{ data: ResponseDataDashboard }>(endpoint, {
    params: params || {},
  });
  console.log('Response from Post Home API:', endpoint, response.data);
  return response?.data;
};

interface paramsGetListInterface {
  filter?: string
}

export const usePostHome = (type:PostTypeKey, params?:paramsGetListInterface) => {
  const dashboardQuery = useQuery<ResponseDataDashboard>({
    queryKey: [`${KeyQueryApi.DASHBOARD}_${type}`, ApiConfigs.baseURL,params|| {}],
    queryFn: () => fetchPostHomeData(type, params), // No need to pass language
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
console.log('Dashboard Query:', dashboardQuery);
  return {
    dashboardQuery,
  };
};

export default usePostHome;
